/**
 * Skip Link Focus Management
 *
 * Enhances the skip to main content link with proper focus management.
 * Ensures keyboard navigation works correctly across all browsers.
 *
 * @package DemocraticServices
 * @since 3.1.0
 *
 * WCAG 2.1 Compliance:
 * - 2.1.1 Keyboard (Level A) - All functionality operable via keyboard
 * - 2.4.1 Bypass Blocks (Level A) - Mechanism to bypass repeated content
 * - 2.4.3 Focus Order (Level A) - Focus moves in logical order
 * - 2.4.7 Focus Visible (Level AA) - Focus indicator visible
 */

(function () {
	'use strict';

	/**
   * Initialize skip link functionality
   */
	function initSkipLink() {
		const skipLink = document.getElementById('skip-to-main');
		const mainContent = document.getElementById('main-content');

		if (!skipLink || !mainContent) {
			return;
		}

		/**
     * Handle skip link click
     *
     * Moves focus to main content and scrolls into view.
     * Uses smooth scrolling where supported.
     */
		skipLink.addEventListener('click', function (event) {
			event.preventDefault();

			// Scroll to main content
			mainContent.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});

			// Move focus to main content
			mainContent.focus();

			// Update URL hash without causing jump
			if (history.pushState) {
				history.pushState(null, null, '#main-content');
			}
		});

		/**
     * Handle Enter key on skip link
     *
     * Ensures keyboard activation works consistently.
     */
		skipLink.addEventListener('keydown', function (event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				this.click();
			}
		});

		/**
     * Remove outline from main content when clicking inside it
     *
     * This prevents the focus outline from appearing when users
     * click inside the main content area (they're already there).
     */
		mainContent.addEventListener('mousedown', function () {
			this.style.outline = 'none';
		});

		/**
     * Restore outline on keyboard focus
     *
     * Ensures keyboard users still see focus indicator.
     */
		mainContent.addEventListener('keydown', function () {
			this.style.outline = '';
		});

		/**
     * Handle page load with hash
     *
     * If page loads with #main-content hash, focus the main content.
     */
		if (window.location.hash === '#main-content') {
			requestAnimationFrame(function () {
				mainContent.focus();
			});
		}
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSkipLink);
	} else {
		initSkipLink();
	}
})();
